import React, { useState } from "react";
import { Space, Select, Input } from "antd";

const NewsFilters = ({ filters, onFiltersChange }) => {
  return (
    <Space size="large">

      <div>
        Active :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 120 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, isActive: value })}
        >
          <Select.Option value={true}>Yes</Select.Option>
          <Select.Option value={false}>No</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default NewsFilters;
